export enum RequestMethodRoleEnum {
    admin = 'admin',
    seller = 'seller',
    user = 'user',
    employee = 'employee',
    global = '/'
}